import axios from "@/lib/axios";
import { API_WEB } from "../utils/constants";

const csrf = () => axios.get("/sanctum/csrf-cookie");

export async function getUserStats() {
  await csrf();

  const response = await axios.get(`${API_WEB}/user/stats`);

  if (response.status !== 200) {
    throw new Error(response.response.data.message);
  }
  return response.data;
}
